import axios from "axios";
import { COREAPI_ENDPOINTS } from "../../config";

export async function getPoli() {
  return await axios.get(COREAPI_ENDPOINTS.URL + COREAPI_ENDPOINTS.PATH_POLI);
}
